import { createSlice } from '@reduxjs/toolkit';
import BaseError from '../../../utils/base-error';
import { CateringFormatPageState } from './catering-format-page-state';
import { CateringFormatPageActions } from './actions';
import { createCateringFormatFromGetCateringFormatBySlugApiResponse } from '../utils';

const initialState: CateringFormatPageState = {
    loaded: false,
    errors: [],
};

export const cateringFormatPageSlice = createSlice({
    name: 'cateringFormatPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            CateringFormatPageActions.getCateringFormatBySlug.fulfilled,
            (state, action) => {
                const response = action.payload;
                console.log(action.payload);
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const result = createCateringFormatFromGetCateringFormatBySlugApiResponse(
                            response.data,
                        );

                        state.cateringFormat = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});
